var _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvailableIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.363 44.637C61.254 48.528 60.837 55.101 56.109 58.416C53.1 60.525 48.9 60.525 45.891 58.416C41.163 55.098 40.743 48.528 44.637 44.637C48.15 41.121 53.85 41.121 57.363 44.637",
    stroke: "url(#paint0_linear_407_2452)",
    strokeWidth: 3.04286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.363 57.363L63 63",
    stroke: "url(#paint1_linear_407_2452)",
    strokeWidth: 3.04286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 30H15C11.685 30 9 27.315 9 24V15C9 11.685 11.685 9 15 9H24C27.315 9 30 11.685 30 15V24C30 27.315 27.315 30 24 30Z",
    stroke: "url(#paint2_linear_407_2452)",
    strokeWidth: 3.04286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57 30H48C44.685 30 42 27.315 42 24V15C42 11.685 44.685 9 48 9H57C60.315 9 63 11.685 63 15V24C63 27.315 60.315 30 57 30Z",
    stroke: "url(#paint3_linear_407_2452)",
    strokeWidth: 3.04286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 63H15C11.685 63 9 60.315 9 57V48C9 44.685 11.685 42 15 42H24C27.315 42 30 44.685 30 48V57C30 60.315 27.315 63 24 63Z",
    stroke: "url(#paint4_linear_407_2452)",
    strokeWidth: 3.04286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_407_2452",
    x1: 40.4254,
    y1: 50.9989,
    x2: 62.3607,
    y2: 50.9989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F7F90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B08A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_407_2452",
    x1: 56.8698,
    y1: 60.1815,
    x2: 63.7399,
    y2: 60.1815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F7F90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B08A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_407_2452",
    x1: 7.1625,
    y1: 19.5,
    x2: 32.7562,
    y2: 19.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F7F90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B08A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_407_2452",
    x1: 40.1625,
    y1: 19.5,
    x2: 65.7562,
    y2: 19.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F7F90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B08A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_407_2452",
    x1: 7.1625,
    y1: 52.5,
    x2: 32.7562,
    y2: 52.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F7F90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B08A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvailableIcon);
export default __webpack_public_path__ + "static/media/available-icon.12db18395bd313b6067bad1b0a634c4d.svg";
export { ForwardRef as ReactComponent };